import React, { useState, createContext, useEffect } from "react";
import {
  BrowserRouter,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import "./App.css";
import { GET_CUSTOMER_DETAILS } from "./Config";
import PageContainer from "./components/container/PageContainer";
import PageNotFound from "./pages/other-pages/Page404";
import EplRoutes from "./sourceRoutes/EplRoutes";
import UpsellRoutes from "./sourceRoutes/UpsellRoutes";
import { encrypt } from "./utils/crypto";
import sendRequest from "./utils/sendRequest";
import { getRouteFromLoanStageService } from "./shared/services/getRouteFromLoanStageService";
import { CheckInternetModal, DesktopModeCheckModal } from "./pages/other-pages/Modals/AllModal";
import LoanExpired from "../src/assets/svg/EPL_think_svg/loan_expired.svg"
import { encryptedData } from "./utils";

export const GetCustomerDetailsContext = createContext();
export const validateInputExistenece = (input) => {
  return ![undefined, null].includes(input);
};

export const GetCustomerDetails = async (
  applicationNumber,
  source,
  customerDetails,
  setCustomerDetails,
  navigate
) => {
  // console.log("In GetCustomerDetails");
  // console.log("\tI AM ON APP", applicationNumber);
  // const navigate = useNavigate();
  // const location = useLocation();
  // const [customerDetails, setCustomerDetails] = useState();
  //   const source = location.pathname.split("/")[1];
  var payload = {
    application_form_number: applicationNumber,
  };
  try {
    // console.log("\tgetCUstomerDetails TRY BLOCK");
    const formData = new FormData();
    formData.append("data", encryptedData(payload));
    const response = await sendRequest(
      "/" + source + GET_CUSTOMER_DETAILS,
      formData
    );
    // console.log("\tgetCUstomerDetails Response: ", response);
    // console.log("\tgetCUstomerDetails Response Data: ", response.response.Data);
    if (response.response.Success) {
      const updated = customerDetails;
      updated.application_form_number =
        response.response.Data.application_form_number;
      updated.stage = response.response.Data.stage;
      updated.Data = response.response.Data;
      updated.source = source;
      setCustomerDetails({
        ...updated,
      });
      // console.log(
      //   "\tresponse.response.Data.application_form_number",
      //   response.response.Data.application_form_number
      // );
      // sessionStorage.setItem("abcplAuth", "authenticated");
      // console.log(
      //   "\tresponse.response.Data.stage: ",
      //   response.response.Data.stage
      // );
      // console.log("\tSetting Customer Details");
      //   setCustomerDetails({
      //     ...customerDetails,
      //     application_form_number: response.response.Data.application_form_number,
      //     stage: response.response.Data.stage,
      //     Data: response.response.Data,
      //   });
    }
  } catch (error) {
    if (error === "Unauthorised") {
      // var route = getRouteFromLoanStageService({
      //   source: source,
      //   stage: "",
      // });
      // navigate(`${route}`, {
      //   replace: true,
      // });
      const currentURL = window.location.href;
      const lastSlashIndex = currentURL.lastIndexOf("/");
      const resultURL = currentURL.slice(0, lastSlashIndex);
      window.location.replace(resultURL + "/login");
      } else {
      console.error(`\tUnknown Error: Constants Not Retireved - ${error}`);
      var route = getRouteFromLoanStageService({
        source: source,
        stage: "error",
      });
      navigate(`${route}`, {
        replace: true,
      });
    }
  }
  // console.log("Out GetCustomerDetails");
};

const App = () => {
  // console.log("App called");
  const [customerDetails, setCustomerDetails] = useState({
    application_form_number: null,
    stage: null,
    Data: null,
    source: null,
  });
  const [usingDesktop, setUsingDesktop] = useState();

  useEffect(() => {
    let details = navigator.userAgent;
    let regexp = /android|iphone|ipad/i;
    let isMobileDevice = regexp.test(details);
    if (isMobileDevice) {
        setUsingDesktop(false);
    } else {
        setUsingDesktop(true);
    }
}, [])

  // const[internetCheck,setInternetCheck] = useState(true);
  // console.log(window.navigator.onLine);

  // useEffect(() => {
  //   setInternetCheck(window.navigator.onLine);
  // })

  // console.log(customerDetails);
  return (
    <BrowserRouter>
      <PageContainer>
        <Routes>
          {/* <Route path={`index`} element={<EPL />} /> */}
          <Route
            path={`/upsell/:path`}
            element={
              <GetCustomerDetailsContext.Provider
                value={[customerDetails, setCustomerDetails]}
              >
                <UpsellRoutes />
              </GetCustomerDetailsContext.Provider>
            }
          />
          <Route
            path={`/epl/:path`}
            element={
              <GetCustomerDetailsContext.Provider
                value={[customerDetails, setCustomerDetails]}
              >
                <EplRoutes />
              </GetCustomerDetailsContext.Provider>
            }
          />
          <Route path={`*`} element={<PageNotFound />} />
        </Routes>
        {/* {(!internetCheck && <CheckInternetModal
            isOpen={!internetCheck}
            onClose={() => {
              setInternetCheck(false);
          }}
          />)} */}
          {<DesktopModeCheckModal
            isOpen={usingDesktop}
            modalImage={LoanExpired}
            onClose = {()=>{}}
          />}
      </PageContainer>
    </BrowserRouter>
  );
};

export default App;
